module.exports = __webpack_public_path__ + "media/images/svg/company-fef4618f9bfb6fee5240a1073378fc1d.svg";